module.exports = __webpack_public_path__ + "img/8903d61.jpg";